import * as React from "react"
import * as style from "./style.scss"

/**
 * Blue loading spinner
 */
export default React.memo((): JSX.Element => (
    <div className={style.loading}>
        <div className={style.spinner}>
            <div className={style.doubleBounce1} />
            <div className={style.doubleBounce2} />
        </div>
    </div>
))

/**
 * Grey loading spinner
 */
export const Subtle = React.memo((): JSX.Element => (
    <div className={`${style.loading} ${style.subtle}`}>
        <div className={style.spinner}>
            <div className={style.doubleBounce1} />
            <div className={style.doubleBounce2} />
        </div>
    </div>
))
